export enum AmountType {
  Hourly = 'hourly',
  Monthly = 'monthly',
  Yearly = 'yearly',
}
